/**
 *  运费单
 * @author FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/09/14      1.0    First version   使用统一的表格组件
 *
 * @copyright 2021-2022, all rights reserved. Essa.cn
 * */

import React,{Fragment} from 'react'
import { Spin, Descriptions} from 'antd';
import Lang from "@components/Lang/Lang";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import PropTypes from "prop-types";
import History from "./common/History";
import {toFixed2,isEmptyObject} from '@utils/utils';
import DownloadBtnModal from "./common/DownloadBtnModal";
import HistoryBtnModal from './common/HistoryBtnModal';
import ConfirmAlert from './common/ConfirmAlert'
import {getInfo} from "./common/Info";
import PageCommon from  "@components/PageCommon/PageCommon";
import { getIntlYYMMDD,} from '@utils/utils';

export default class Freight extends React.Component{
    static propTypes = {
        orderType: PropTypes.string.isRequired,
    }
    static defaultProps = {
        orderType:'',
    }
    constructor(props) {
        super(props);
        this.state = {
            list:[],
            orderInfo: {},
            loading:true,
            //历史记录面板
            isShowHistoryPanel:false,
            isShowHistoryId:null,
        }
    }
    getData(){
        this.onRefTabChildOne.handleFetch(1,{},true)
    }
    /**
     * 展示历史记录面板
     * @param item
     */
    showHistoryPanel(item){
        this.setState({
            isShowHistoryPanel:true,
            isShowHistoryId:item.id,
        })
    }
    /**
     * 隐藏历史记录面板
     **/
    hideHistoryPanel(){
        this.setState({
            isShowHistoryPanel:false,
        })
    }
    /**
     * 获取栏目 // 列
     * */
    getColumns(orderInfo={}){
        const spicTitle = Lang({id: "DaoHaiGuanGuanKaJianChaZhanYunFei",params:[orderInfo.startPlaceName||'-']});
        let columns =   [
            {
                cnTitle: '服务描述',
                width:200,
                cnTitleId: 'FuWuMiaoShu',
                dataIndex: "serviceDesc",
                render: (text, item, index) => { return (item.freightMode ==2?<div>
                    {Lang({ id: "GenJuNianYueRiYiShangYeFa", default:`根据 ${getIntlYYMMDD(orderInfo.actLoadDate)} 以NO.${orderInfo.containerCode} 商业发票交付一批货物`,params:[orderInfo.actLoadDate?getIntlYYMMDD(orderInfo.actLoadDate):"-",orderInfo.containerCode] })}
                </div>:<div>
                    <p>{Lang({id: "JiZhangXiangHuoHao",default: "集装箱货号"})}</p>
                    <p className={"font-main"}>{text}</p>
                </div>)}
            },
            {
                cnTitle: '交货用时',
                width:150,
                cnTitleId: 'JiaoHuoYongShi',
                dataIndex: "deliveryTime"
            },
            {
                cnTitle: '发货点',
                width:150,
                cnTitleId: 'FaHuoDian',
                dataIndex: "domesticStartPlaceName"
            },
            {
                cnTitle: '目的点',
                width:150,
                cnTitleId: 'MuDiDian',
                dataIndex: "endPlaceName"
            },
            {
                cnTitle: '路线',
                cnTitleId: 'LuXian',    
                dataIndex: "domesticRouteId",
                width:250,
                render: (text, item, index) => {
                    return (item.freightMode==0||item.freightMode==2)? (<div dangerouslySetInnerHTML={{__html:Lang({
                            id: item.freightMode==2?"YunFeiDanLuXianMiaoShu2":"YunFeiDanLuXianMiaoShu",
                            params:[`${item.startPlaceName||'-'}`,
                                `<b>${item.domesticRouteName||'-'}</b>`,
                                `<b> ${item.domesticKilometers||'-'}</b>`,
                                `<b> ${item.abroadRouteName||'-'}</b>`,
                                `<b> ${item.abroadKilometers||'-'}</b>`,
                                `<b> ${item.domesticRoutePriceRatio||'-'}</b>`,
                                `<b> ${item.abroadRoutePriceRatio||'-'}</b>`
                            ]})}}>
                    </div>):(<div dangerouslySetInnerHTML={{__html:Lang({id: 'HaiGuanGuanQiaTongXingJianChaZhan',
                            params:[
                                `<b>${item.endPlaceName||'-'}</b>`,    
                                `<b> ${item.domesticKilometers||'-'}</b>`,
                            ]})}}>
                    </div>)
                }
            },
            {
                cnTitle: '付款条件',
                cnTitleId: 'FuKuanTiaoJian',
                width:150,
                dataIndex: "paymentCondition"
            },
            {
                title: spicTitle,
                width:150,
                dataIndex: "domesticRoutePrice",
                render: (text, item, index) => {
                    return (<>{text?<>{item.currencyCode||""}<span className={"ml_6"}>{text}</span></>:""}</>)
                }
            },
            {
                // cnTitle: orderInfo.freightMode ==2?'海关关卡路线运费':'欧亚经济联盟路线运费',
                // cnTitleId: orderInfo.freightMode ==2?'HaiGuanGuanKaLuXianYunFei':'OuYaJingJiLianMengLuXianYunFei',
                title: orderInfo.freightMode ==2?Lang({id: "HaiGuanGuanKaLuXianYunFei",
                    default:`从${orderInfo.startPlaceNameZh}中转站到${orderInfo.endPlaceNameZh}海关检查站运费`,
                    params:[orderInfo.startPlaceNameZh||'-',orderInfo.endPlaceNameZh||'-']}):Lang({id:'OuYaJingJiLianMengLuXianYunFei',default:'欧亚经济联盟路线运费'}),
                width:150,
                dataIndex: "abroadRoutePrice",
                render: (text, item, index) => {
                    return (<>{text?<>{item.currencyCode||""}<span className={"ml_6"}>{text}</span></>:""}</>)
                }
            },
            {
                cnTitle: '总计运费',
                cnTitleId: 'ZongJiYunFe',
                dataIndex: "totalPrice",
                render: (text, item, index) => {
                    return (<>{text?<>{item.currencyCode||""}<span className={"ml_6"}>{text}</span></>:""}</>)
                }
            },
        ]

        if(this.state.orderInfo && this.state.orderInfo.freightMode ==1){
            delete columns[6]
            delete columns[7]
        }        
        // var data = columns.map(col => {
        //     if(col.className !== 'hide'){
        //         return col;
        //     }

        // })

        return columns
        // console.log(data)

        // return columns.map(col => {
        //     return col.className != 'hide'
        // });
    }
    /**
     * 加载状态
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 设置 信息头
     * */
    setOrderInfo(res){
        this.setState({
            orderInfo:res.model,
            orderExtra:res.extra
        })
        this.loading(false);
        this.onRefTabChildOne.reRefreshColumns();//获取到值刷新栏目
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    componentDidMount() {
        if(this.props.onRef)this.props.onRef(this);
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }

    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref; 
    render(){
        const { orderInfo={},loading=true, isShowHistoryPanel, orderExtra={} } = this.state;
        const {orderType,containerId,downloadUrlExcel,downloadUrlPdf} = this.props;
        const columnsSpe = this.getColumns(orderInfo)
        let btnList = []
        if(!isShowHistoryPanel){
            btnList= [
                { 
                    btn: <DownloadBtnModal  title={<div>
                        <i className='ri-download-2-line color-blue mr_4'></i>
                        {Lang({id: "XiaZaiExcel",default: "下载Excel"})}
                    </div> }
                    downloadUrl={downloadUrlExcel}
                    orderInfo={orderInfo} />,
                    btnClick:()=>{}
                },{ 
                    btn: <DownloadBtnModal title={<div>
                        <i className='ri-download-2-line color-danger mr_4'></i>
                        {Lang({id: "XiaZaiGaiZhangPDF",default: "下载盖章PDF"})}
                    </div>}
                    downloadUrl={downloadUrlPdf}
                    orderInfo={orderInfo} type={'pdf'} />,
                    btnClick:()=>{}
                },{ 
                    btn: <HistoryBtnModal className={"margin-left-5"}
                    title={Lang({id: 'LiShiJiLu', default: '历史记录'})}
                    orderType={orderType}
                    recoveryHistoryBack={this.getData.bind(this)}
                    showHistoryPanel={item=>this.showHistoryPanel(item)}
                    containerId={containerId} />,
                    btnClick:()=>{}
                }
            ]
    
    
            if(orderInfo.status === '10' || orderInfo.status === '20'){
                btnList.push({
                    btn: <ConfirmAlert orderInfo={orderInfo} orderType={orderType} callBack={()=>this.getData()} />,
                    btnClick:()=>{}
                })
            }
        }

        return (
            <PageCommon onRef={this.onRefPageCommon} className={"transferWrap"} btnList={btnList}>
            <div className={"packListWrap"}>
                {isShowHistoryPanel?<History id={this.state.isShowHistoryId} orderType={orderType}
                                             loading={loading}
                                             columns = {columnsSpe}
                                             type={'2'}
                                             scroll={{x:1500}}
                                             callBackFields = {['model']}
                                             fetchApi={'/service/mg/con/report/freight-order/details'}
                                             callBack={this.hideHistoryPanel.bind(this)} />:<Spin spinning={loading}>
                                <AutoFetchTable columns={columnsSpe}
                                                onRef={this.onRefTabOne}
                                                callBackFields = {['model']}
                                                paginationFlag={false}
                                                bordered={true}
                                                scroll={{x:1500}}
                                                fetchCallBack={(res)=>this.setOrderInfo(res)}
                                                precondition={{containerId:containerId}}
                                                fetchApi={'/service/mg/con/report/freight-order/details'} >
                                    {orderInfo&&orderInfo.id&&<div>
                                        <div className={"color-danger fw_700 font_18"}>{Lang({id: 'YunFeiDan', default: '运费单'})}</div>
                                        {/* 表头 */}
                                        {getInfo(orderType,orderInfo)}
                                        {/* 表头 END */}
                                    </div>}
                                </AutoFetchTable>
                    {/* 运费报价单 */}
                    {loading?null:<Fragment>
                    <div className={"color-danger fw_700 font_18 mt_16"}>{Lang({id: 'YunFeiBaoJiaDan', default: '运费报价单'})}</div>
                       {isEmptyObject(orderInfo)?<div className={"color-red fw_700 font_14 mt_16"}>
                           {Lang({id: 'YunFeiDanShangWeiSheZhi', default: '运费单尚未设置'})}
                       </div>:<Fragment>
                                {/* 表头 */}
                                {getInfo("freightPay",orderInfo)}
                                {/* 表头 END */}
                                <table className={"borderTable mt_16"} bordered>
                                    <tbody>
                                    <tr>
                                        <th>No.</th>
                                        <th>{Lang({id: 'ChuFaDi', default: '出发地'})}</th>
                                        <th>{Lang({id: 'MuDiDi', default: '目的地'})}</th>
                                        <th>{Lang({id: 'ShiJian', default: '时间'})}</th>
                                        <th>{Lang({id: 'YunFeiZongJi', default: '运费总计'})},{orderInfo.currencyCode}</th>
                                    </tr>
                                   {orderInfo.freightMode==1?<tr>
                                       <td>1</td>
                                       <td>{orderInfo.domesticStartPlaceName}</td>
                                       <td>{orderInfo.endPlaceName}</td>
                                       <td>{Lang({id: 'NTian', default: '{0}天',params:["7-14"]})}</td>
                                       <td>{orderInfo.totalPrice}</td>
                                       </tr>:<Fragment> <tr>
                                       <td>1</td>
                                       <td>{orderInfo.domesticStartPlaceName}</td>
                                       <td>{orderInfo.startPlaceName}</td>
                                       <td rowSpan={2}>{Lang({id: 'NTian', default: '{0}天',params:["20-25"]})}</td>
                                       <td>{orderInfo.domesticRoutePrice}</td>
                                   </tr>
                                       <tr>
                                           <td>2</td>
                                           <td>{orderInfo.startPlaceName}</td>
                                           <td>{orderInfo.endPlaceName}</td>
                                           <td>{orderInfo.abroadRoutePrice}</td>
                                       </tr></Fragment>}
                                    <tr>
                                        <td colSpan={4} style={{textAlign:"right"}}>{Lang({id: 'ZongJi', default: '总计'})}</td>
                                        <td>{orderInfo.totalPrice}</td>
                                    </tr>
                                    </tbody>
                                </table>
                               </Fragment>}
                            </Fragment>}
                </Spin>}
            </div>
            </PageCommon>
        )
    }
}
